import { Component, Input } from '@angular/core';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { UploadedFile } from '../../models/uploaded-file.model';
import { LoaderButtonType } from '../../../shared/models/loader-button-type.enum';

@Component({
standalone: false,
  selector: 'app-add-liability-scan-desktop',
  styleUrls: ['./add-liability-scan-desktop.component.scss'],
  templateUrl: './add-liability-scan-desktop.component.html',
})
export class AddLiabilityScanDesktopComponent {
  @Input() public files: UploadedFile[] = [];
  @Input() public error: string;
  @Input() public uploading: boolean;
  @Input() public disabled: boolean;
  @Input() public addDroppedFile: (files: NgxFileDropEntry[]) => void;
  @Input() public filesAdded: (event: Event) => void;
  @Input() public showDropArea: () => void;
  @Input() public hideDropArea: () => void;
  @Input() public remove: (index: number) => void;
  @Input() public submit: () => void;

  public documentPreviewVisible = false;
  public readonly formName = 'newLiability';
  protected readonly HTMLInputElement = HTMLInputElement;
  protected readonly LoaderButtonType = LoaderButtonType;
}
